import { TableHead, TableRow } from "@material-ui/core";
import React from "react";
import { globalColors } from "../../../../../../../../../_metronic/_assets/sass/custom/globalColors";

import { StyledTableCell } from "../../../../../../../../partials/datatable/styles";

export const TableHeadContent = ({ tableHeaders }) => {
  return (
    <TableHead>
      <TableRow
        style={{
          textAlign: "left",
          backgroundColor: globalColors.secondaryColor3,
        }}
      >
        {tableHeaders.map((header, index) => (
          <StyledTableCell
            key={index}
            style={{
              textAlign:
                header === "Ações" || header === "Data de Modificação"
                  ? "center"
                  : "left",
              backgroundColor: globalColors.secondaryColor3,
            }}
          >
            {header}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
